// Route guard for the BA screens (BA P1.6a, WP-2d): a direct URL opens only
// when its gate holds — `self` (BaSelfGate's rule: ba_platform flag +
// brand_ambassadors entitlement + ba:profile:self) for a Brand Ambassador's own
// screens, `manage` (BaManageGate's rule: flag + entitlement + ba:profile:review
// or services:booking:manage) for the roster, review and "What clients see".
// Otherwise back to the dashboard, like the other entitlement-gated routes.
// UX only — the services answer 404 regardless.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useBaManageEnabled, useBaSelfEnabled } from '@/features/entitlements/brandAmbassadors';

export type BaRouteGate = 'self' | 'manage';

const SelfRoute: React.FC<{ children: React.ReactNode; fallback: string }> = ({ children, fallback }) => {
  const { loaded, enabled } = useBaSelfEnabled();
  if (!loaded) return <div className="p-8 text-center text-muted-foreground">…</div>;
  return enabled ? <>{children}</> : <Navigate to={fallback} replace />;
};

const ManageRoute: React.FC<{ children: React.ReactNode; fallback: string }> = ({ children, fallback }) => {
  const { loaded, enabled } = useBaManageEnabled();
  if (!loaded) return <div className="p-8 text-center text-muted-foreground">…</div>;
  return enabled ? <>{children}</> : <Navigate to={fallback} replace />;
};

export const BaRoute: React.FC<{ gate: BaRouteGate; children: React.ReactNode; fallback?: string }> = ({
  gate, children, fallback = '../dashboard',
}) => (gate === 'self'
  ? <SelfRoute fallback={fallback}>{children}</SelfRoute>
  : <ManageRoute fallback={fallback}>{children}</ManageRoute>);

export default BaRoute;
